import Model, { attr } from '@ember-data/model';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';

export default class AllFundsJournalSlimModel extends Model {
  @service declare formatDateService: any;

  @attr('string') name!: string;
  @attr('string') fundId!: string;
  @attr('string') fundName!: string;
  @attr('string') reportName?: string;
  @attr('date-only') startDate!: Date;
  @attr('date-only') goalDate!: Date;
  @attr('date-only') closedDate!: Date;

  get label() {
    return isPresent(this.name)
      ? this.name
      : this.formatDateService.format(this.goalDate);
  }

  get active() {
    return this.closedDate == null || this.closedDate > new Date();
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'all-funds/journal-slim': AllFundsJournalSlimModel;
  }
}
